<template>
    <div>
        <ob-modal2 :show.sync="show" width="900px" :backdrop="false" id="scrollable-containerT">
            <template slot="modal-title">
                <div class="modal-head">
                    <h4 class="modal-title" v-if="IsTraininplanRequsted && !isverify">
                       Complete Training Plan
                    </h4>
                    <h4 class="modal-title" v-else-if ="!IsTraininplanRequsted && !IsReviewTrainingPlan">
                    {{ isverify ? 'Verify' : 'Update' }} Training Plan
                    </h4>
                    <h4 class="modal-title" v-else-if="IsReviewTrainingPlan">
                        Review Training Plan for STEM OPT  Students
                    </h4>
                    <h4 class="modal-title" v-else>
                        Update Training Plan
                    </h4>
                </div>
            </template>
    
            <template slot="modal-body">
                <p style="color: rgb(77, 146, 223)" v-if="!isverify">
                    <b>
                        Note : <template v-if="isHRManager">This training plan is created/confirmed by the student. Any changes in this plan will be updated for the student as well.</template> Please report the updated Training Plan to the DSO.
                    </b>
                </p>
                 <div class="row rowgap" v-if="content.SignatureType != 'Electronic'">
                    <label class="col-md-12" style="font-weight: bold;color: rgb(0, 0, 0);margin-bottom: 15px;">Fill the details of the Signatory Authority/Supervisor</label>
                    
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Signatory Authority</label> <span class="validation-star">*</span><i class="fa fa-info-circle" v-tooltip="'You can add Signatory Authority from settings.'"></i>
                            <ob-select2 :inModal="true" v-if="showSignatoryauthorityList" :options="signatoryauthorityList" v-model.trim="selectedSignatoryAuthorityEmail"  :class="{ 'ob-vuelidate_input-error': $v.selectedSignatoryAuthorityEmail.$error }"></ob-select2>
                            <span class="ob-vuelidate_error-msg" v-if="$v.selectedSignatoryAuthorityEmail.$dirty && !$v.selectedSignatoryAuthorityEmail.required"> Select Signatory Authority</span>
                        </div>
                    </div>
                </div>
    
                 <div class="row rowgap">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Name of Official</label><span class="validation-star">*</span>
                            <ob-input :disabled="true" v-model.trim="AssignedTraining.SignatoryAuthority.Name" placeholder="Enter Name of Official" :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SignatoryAuthority.Name.$error }" @input="updateValue(AssignedTraining.SignatoryAuthority.Name)"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty && !$v.AssignedTraining.SignatoryAuthority.Name.required"> Enter Name of Official</span>
                            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty && !$v.AssignedTraining.SignatoryAuthority.Name.alphawithspace"> Enter alphabets only</span> -->
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty && !$v.AssignedTraining.SignatoryAuthority.Name.maxLength && $v.AssignedTraining.SignatoryAuthority.Name.alpha"> Enter 150 characters only</span>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty &&  $v.AssignedTraining.SignatoryAuthority.Name.alpha && !$v.AssignedTraining.SignatoryAuthority.Name.letterCount">Each word can have a maximum of 100 characters only.</span>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Official's Title</label><span class="validation-star">*</span>
                            <ob-input :disabled="true" v-model.trim="AssignedTraining.SignatoryAuthority.Title" placeholder="Enter Official's Title" :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SignatoryAuthority.Title.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Title.$dirty && !$v.AssignedTraining.SignatoryAuthority.Title.required"> Enter Official's Title</span>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Title.$dirty && !$v.AssignedTraining.SignatoryAuthority.Title.maxLength && $v.AssignedTraining.SignatoryAuthority.Title.alpha"> Enter 150 characters only</span>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Title.$dirty &&  $v.AssignedTraining.SignatoryAuthority.Title.alpha && !$v.AssignedTraining.SignatoryAuthority.Title.letterCount">Each word can have a maximum of 100 characters only.</span>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Official's Email</label><span class="validation-star">*</span>
                            <ob-input :disabled="true" v-model.trim="AssignedTraining.SignatoryAuthority.Email" placeholder="Enter Official's Email" :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SignatoryAuthority.Email.$error }"></ob-input>
                             <template v-if="$v.AssignedTraining.SignatoryAuthority.Email.$dirty">
                                    <span class="ob-vuelidate_error-msg" v-if="!$v.AssignedTraining.SignatoryAuthority.Email.required"> Enter Official's Email</span>
                                    <span class="ob-vuelidate_error-msg" v-else-if="!$v.AssignedTraining.SignatoryAuthority.Email.email"> Enter valid email</span>
                            </template>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Official's Phone Number</label>
                            <ob-input onkeypress='return event.charCode >= 48 && event.charCode <= 57' v-model.trim="AssignedTraining.SignatoryAuthority.Phone" placeholder="Enter Official's Phone Number" ></ob-input>
                            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Phone.$dirty && !$v.AssignedTraining.SignatoryAuthority.Phone.required"> Enter Phone Number</span> -->
                        </div>
                    </div>    
                   
                    
                </div>
    
                
    
                <div class="row rowgap">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Site Name</label><span class="validation-star">*</span>
                            <ob-input v-model.trim="AssignedTraining.SiteName" placeholder="Enter Site Name" :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SiteName.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SiteName.$dirty && !$v.AssignedTraining.SiteName.required"> Enter Site Name</span>
    
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SiteName.$dirty && !$v.AssignedTraining.SiteName.maxLength && $v.AssignedTraining.SiteName.alpha"> Enter 150 characters only</span>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SiteName.$dirty &&  $v.AssignedTraining.SiteName.alpha && !$v.AssignedTraining.SiteName.letterCount">Each word can have a maximum of 100 characters only.</span>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>Site Address (Street, City, State, ZIP)</label><span class="validation-star">*</span>
                            <ob-input  v-model.trim="AssignedTraining.SiteAddress" placeholder="Enter Site Address (Street, City, State, ZIP)" :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SiteAddress.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SiteAddress.$dirty && !$v.AssignedTraining.SiteAddress.required"> Enter Site Address</span>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SiteAddress.$dirty && !$v.AssignedTraining.SiteAddress.maxLength && $v.AssignedTraining.SiteAddress.alpha"> Enter 150 characters only</span>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SiteAddress.$dirty &&  $v.AssignedTraining.SiteAddress.alpha && !$v.AssignedTraining.SiteAddress.letterCount">Each word can have a maximum of 100 characters only.</span>
                        </div>
                    </div>
                </div>
    
                <div class="row rowgap">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Training Plan Title</label><span class="validation-star">*</span>
                               <ob-input v-model.trim="TrainingPlan.Title" placeholder="Enter Training Plan Title" :class="{ 'ob-vuelidate_input-error': $v.TrainingPlan.Title.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.TrainingPlan.Title.$dirty && !$v.TrainingPlan.Title.required"> Enter Training Plan Title</span>
                            </div>
                        </div>
                    </div>
                     <div class="row rowgap">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Student Role: Describe the student's role with the employer and how that role is directly related to enhancing the student's knowledgeobtained through his or her qualifying STEM degree.</label>
                                <ob-textarea  v-model.trim="TrainingPlan.StudentRole" placeholder="Enter student roles"></ob-textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row rowgap">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Goals and Objectives: Describe how the assignment(s) with the employer will help the student achieve his or her specific objectives for workbased learning related to his or her STEM degree. The description must both specify the student's goals regarding specific knowledge, skills, or techniques as well as the means by which they will be achieved.</label>
                                <ob-textarea  v-model.trim="TrainingPlan.GoalsAndObjectives" placeholder="Enter Goals and Objectives"></ob-textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row rowgap">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Employer Oversight: Explain how the employer provides oversight and supervision of individuals filling positions such as that being filled by the named F-1 student. If the employer has a training program or related policy in place that controls such oversight and supervision, please describe.</label>
                                <ob-textarea  v-model.trim="TrainingPlan.EmployerOversight" placeholder="Enter Employer Oversight"></ob-textarea>
                            </div>
                        </div>
                    </div>
                      <div class="row rowgap">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Measures and Assessments: Explain how the employer measures and confirms whether individuals filling positions such as that being filled by the named F-1 student are acquiring new knowledge and skills. If the employer has a training program or related policy in place that controls such measures and assessments, please describe.</label>
                                <ob-textarea  v-model.trim="TrainingPlan.MeasuresAndAssessments" placeholder="Enter Measures and Assessments"></ob-textarea>
                            </div>
                        </div>
                    </div>
                     <div class="row rowgap">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Additional Remarks (optional): Provide additional information pertinent to the Plan.</label>
                                 <ob-textarea  v-model.trim="TrainingPlan.Remarks" placeholder="Enter Additional Remarks"></ob-textarea>
                            </div>
                        </div>
                    </div>
    
                     <div class="row rowgap" v-if="show">
                        <div class="col-md-12">
                            <div class="form-group">
    
                                <div  v-for="(doc,index) in SupportingDocuments" :key="index">
                                <label> Upload Supporting Document ( Attachment ) </label>
                                    <a @click="removeDocument(index)" class="remove-doc" v-if="index != 0">-Remove document</a>
                                    <p style="font-style: italic; margin-bottom: 10px; font-size: 12px;">We accept either pdf, .doc, .docx, zip, images upto 100MB.</p>
                                <transition name="slide-fade">
                                    <ob-upload-new ref="child1" :validation="documantValidation" :end-point="EndPoint" @file-complete="uploadComplete(index, ...arguments)" @remove-file="SupportingDocuments[index].DocUrl = ''" :IsFileExists="IsDocExist(SupportingDocuments[index].DocUrl) | I9URL2FileName" :type="2"  :isUploading.sync="isUploading">
                                                        <template slot="file-text">
                                                            <i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop   OR  Choose  The File
                                                        </template>
                                    </ob-upload-new>
                                </transition>
                                <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="SupportingDocuments[index].isErrorMessageDisabled && $refs.child1[index].Errors.length==0" >{{SupportingDocuments[index].errorMessageFrmResponse}} </span>
                                </div>
                                <div class="row m0">
                                    <a @click="addDocument(SupportingDocuments)" class="add-doc">  + Add new document</a>
                                </div>
                                <div class="form-group">
                                 <label style="margin-top: 2%;">Supporting Links</label>
                                  <ob-select2 :inModal="true" v-model.trim="SupportingLinks" :options="SupportingLinkOptions" :multiple="true"></ob-select2>
                                 </div>
                            </div>
                        </div>
                    </div>
                    <div  v-if="ShowSignatureForTrainingPlan">
                        <div class="col-md-6">
                           <div class="form-group">
                            <label class="label_title">
                                Signature of Employer Official with Signatory Authority <span class="validation-star">*</span>
                                
                            </label>
                                <ob-signature-pad v-if="SignatureDetails.EnableSignature" @scrollToTop="scrollToTop" @SaveSignature="saveSignature" style="margin-top: 30px; padding-left: 0; text-align: left; width: 0px;" :istrainingpopup="true"></ob-signature-pad>
                            <div v-else class="full-width" style="padding-left:0;display: flex;">
                                <div class="custom-sign-div custom-sign-div_inline_style1">
                                    <img :src="SignatureDetails.SignatureURL" :class="{'sign-width': this.SignatureDetails.isDraw, 'add-sign-width': !this.SignatureDetails.isDraw}" alt="Uploaded Signature Url" width="250px" height="100px" style="margin-left: -20px;object-fit: contain;">
                                </div>
                                <div class="custom-sign-div_inline_style2" style="margin-left: 8px;">
                                    <img @click="editSignatureMethod(SignatureDetails.image, true)" :src="`${CDNIMAGESBASEURL}/web/Content/Images/ic_edit.svg`" alt="edit" class="edit-sign-icon"><br />
                                    <img @click="deleteSiganture(SignatureDetails.image)" :src="`${CDNIMAGESBASEURL}/web/Content/Images/ic_delete.svg`" alt="delete" class="delete-sign-icon">
                                </div>
                                <div>
                                <ob-edit-signature-pad @SaveSignatureEdit="SignatureEdit" :editSignature.sync="openEditsignature" :fileName="'HRSign'" :tabType="SignatureDetails.tabType" :data="SignatureDetails.drawImage" :drawImageProp="SignatureDetails.drawImage" :isDraw="SignatureDetails.isDraw" :metaInformation="SignatureDetails.metaInformation" :istrainingpopup="true"></ob-edit-signature-pad>
                            </div>
                            </div>
                           </div>
                        </div>
                        <div class="col-md-12" style="padding: 5px 10px;">
                            <span class="ob-vuelidate_error-msg" style="margin-bottom: 5px;" v-if="$v.SignatureDetails.Base64Url.$dirty && !$v.SignatureDetails.Base64Url.requiredIf ">Please enter signature</span>
                        </div>
                        
                    </div>
                    
                    <div class="row" v-else-if="content.SignatureType == 'Electronic' && SignatureURL && SignatureURL != ''">
                        <div class="col-md-10">
                            <div class="custom-sign-div custom-sign-div_inline_style1">
                                    <img :src="SignatureURL" :class="{'sign-width': this.isDraw, 'add-sign-width': !this.isDraw}" alt="Uploaded Signature Url" width="250px" height="100px" style="margin-left: -20px;object-fit: contain;">
                            </div>
                        </div>
                    </div>
                      
                    <div class="row rowgap" style="padding-left:15px">
                        <ob-checkbox v-model="isCheckboxCkecked">{{isHRManager ? 'I acknowledge that the change in this training plan has been informed to the student' :'I acknowledge that the change in this training plan has been informed to the employer' }}</ob-checkbox>
                    </div>
            </template>
    
            <template slot="modal-footer" class="modal-footer">
                 <ob-button type="secondary" @click="handleCancel">Cancel</ob-button>
                 <ob-button type="primary" :disabled="enableUpdateButton" @click="onUpdateClick">{{ isverify || IsReviewTrainingPlan ? 'Preview Form' : 'Update' }}</ob-button>
            </template>
        </ob-modal2>
    
        </div>
    </template>
    <script>
    import namevalidation from "Vue/Core/namevalidation.js"
    import c from 'Vue/Core/constants.js'
    import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators'
        import { req, withParams } from 'vuelidate/lib/validators/common'
          const DecimalNumber = withParams({ type: 'DecimalNumber' }, value => {
            return !req(value) || /^\d+(\.\d{1,2})?$/.test(value);
        })
         const alphawithspace = (value) => {
         var alsp = /^[a-zA-Z\s]*$/i
         return alsp.test(value)
       }
        const letterCount = withParams({ type: 'letterCount' }, value => {
            if (value !=null && value.length <= 150) {
                var strArr = value.split(" ");
                let error = true;
                strArr.forEach(function (word) {
                    if (word.length > 100) {
                        error = false
                        return;
                    }
                });
                return !req(value) || error
            }
            else {
                return true
            }
    
        })
    
    
        export default {
            props: ["openModal", "content", "isverify","IsReviewTrainingPlan"],
            data() {
                return {
                    location:'',
                    GeoLocation: '',
                    IsNewSignature: false,
                    openEditsignature:false,
                   showSignatoryauthorityList:false,
                   selectedSignatoryAuthorityEmail:'',
                   SignatureURL:'',
                   isDraw:true,
                   IsTraininplanRequsted :false,
                   clonedContent: null,
                   show: '',
                   isCheckboxCkecked:false,
                   TrainingObj:'',
                   SignatureDetails:{
                        SignedDate: moment(new Date()).format("MM/DD/YYYY"),
                        SignatureURL: '',
                        EnableSignature : true,
                        IsNewSignature : true,
                        IsAllowEdit: true,
                        uploadData : "",
                        image : "",
                        tabType : "",
                        drawImage : "",
                        editUpload: false,
                        isDraw: false,
                        Base64Url:'',
                        metaInformation: {}
                    },
                    AssignedTraining:
                    {
                        SiteName:'',
                        SiteAddress:'',
                        SignatoryAuthority:
                        {
                            Name:'',
                            Title:'',
                            Email:'',
                            Phone:''
                        },
                    },
                    TrainingPlan:
                    {
                        Title:'',
                        StudentRole:'',
                        GoalsAndObjectives:'',
                        EmployerOversight:'',
                        MeasuresAndAssessments:'',
                        Remarks:'',
                    },
    
                     signatoryauthorityList: {
                            placeholder: {
                                id: "-1",
                                text: "Select Signatory Authority"
                            },
                            data: []
                    },
    
    
                     SupportingDocuments: [{
                            DocUrl:'',
                            errorMessageFrmResponse:'',
                            isErrorMessageDisabled: false,
                        }],
                     SupportingLinks: '',
    
                      SupportingLinkOptions: {
                         tags: true,
                         tokenSeparators: [','] ,
                        placeholder: {
                            id: '-1', // the value of the option
                            text: 'Please enter'
                        },
                        data: []
                    },
    
    
                    //upload doc
                    DocUrl:'',
                    EndPoint: `${c.APIBASEURL}/File/FileUpload`,
                    isUploading: false,
                    documantValidation: {
                    Rules: {
                            Type: ["pdf", "zip", "doc", "docx", "png", "gif", "jpg", "jpeg"],
                            Size: 110000000, // In Bytes
                            multiplefiles: false
                            },
                    Messages: {
                                Type: "Please upload valid file formats",
                                Size: `Please upload a file which is less than 100MB`,
                                }
                        },
                }
            },
            watch: {
                openModal(val) {
                    this.show = val;
                    if(val) { // On Modal Open
                        this.clonedContent = this.content;
                        // this.getLocation()
                        this.copyFromStore();
                        this._IsTraininplanRequsted();
                        this.getSignatoryauthorityList();
                    }
                },
                show(val) {
                    this.$emit('update:openModal', val)
                },
                 selectedSignatoryAuthorityEmail(v) {
                   this.onChangeSignatoryAuthority(v);
                }
            },
            computed: {
                enableUpdateButton()
                {
                   if(this.isCheckboxCkecked == true)
                   {
                       return false
                   }
                   else return true
                },
                ShowSignatureForTrainingPlan()
                {
                  var show = this.content.SignatureType == 'Electronic' && this.content.AssignedTraining && this.content.AssignedTraining.SignatoryAuthority && this.content.AssignedTraining.SignatoryAuthority.Email == this.loggedInUserObj.email;
                  return show;
                },
            },
            created()
            {
               this.show = this.openModal;
               this.resetData();
            },
             validations(){
                return {
                    "selectedSignatoryAuthorityEmail":{
                            required
                    },
                    SignatureDetails : {
                               Base64Url: {
                                   requiredIf: requiredIf((a) => {
                                       if(this.content.SignatureType == 'Electronic') {
                                           return true
                                       }else{
                                           return false
                                       }
                                   })
                                }
                               },
                    AssignedTraining: {
                        
                        "SiteName": {
                                required,
    
                                maxLength: maxLength(150),
                                letterCount
                            },
                            "SiteAddress": {
                                required,
                                maxLength: maxLength(150),
                                letterCount
                            },
                        "SignatoryAuthority": {
                            "Name": {
                                required,
                                // alphawithspace,
                                maxLength: maxLength(150),
                                letterCount
                            },
                            "Title": {
                                required,
                                alphawithspace,
                                maxLength: maxLength(150),
                                letterCount
                            },
                            "Email": {
                                required,
                                email
                            },
                            // "Phone": {
                            //     required
                            // }
                        },
                    },
                    TrainingPlan: {
                        "Title": {
                            required
                        }
                    },
                    SignatureDetails : {
                           Base64Url: {
                               requiredIf: requiredIf((a) => {
                                   if(this.content.SignatureType == 'Electronic') {
                                       return true
                                   }else{
                                       return false
                                   }
                               })
                           },
                        }
                }
             },
            methods: {
                scrollToTop(val) {
                    if(val) {
                        var a = document.getElementById('scrollable-containerT')
                        a.scroll({
                            top: 700, 
                            left: 0, 
                            behavior: 'smooth'
                        });
                    }else {
                        var a = document.getElementById('scrollable-containerT')
                        a.scroll({
                            top: 1500, 
                            left: 0, 
                            behavior: 'smooth'
                        });
                    }
                },
                getLocation() {
                    if ("geolocation" in navigator) {
                        navigator.geolocation.getCurrentPosition(position => {
                        this.location = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude
                            
                        };
                        if(this.location.latitude && this.location.longitude) {
                            const  url = `${c.APIBASEURL}/Google/GeoLocation?latitude=${this.location.latitude}&longitude=${this.location.longitude}`
                            ajax.get(url, {}, res => {
                                if(res.data.Status) {
                                const tempGeoLocation = res.data.GeoLocation
                                this.GeoLocation = `${tempGeoLocation.City}, ${tempGeoLocation.State}, ${tempGeoLocation.Country}`// var location = geoLocationResponse.City + "," + geoLocationResponse.State + "," + geoLocationResponse.Country
                                
                                }
                            })
                        }
                        }, error => {
                        console.error("Error getting user's location:", error);
                        });
                    } else {
                        console.error("Geolocation is not supported by this browser.");
                    }
                },
                handleCancel() {
                this.show = false
                this.SignatureDetails.SignatureURL=''
                this.SignatureDetails.EnableSignature=true
                this.SignatureDetails.IsNewSignature = true
                this.SignatureDetails.IsAllowEdit=true
                this.SignatureDetails.uploadData=''
                this.SignatureDetails.image=''
                this.SignatureDetails.tabType=''
                this.SignatureDetails.drawImage=''
                this.SignatureDetails.editUpload=false
                this.SignatureDetails.isDraw=false
                this.SignatureDetails.Base64Url=''
                this.SignatureDetails.metaInformation={}
               
            },
            editSignatureMethod(imgUrl, bool){
            // this.resetAttestation()
            if(imgUrl){
                let specialchar = 'data:image/jpeg;base64';
                this.SignatureDetails.drawImage = '';
                let regexPattern = new RegExp(`[${specialchar}]`, 'g');
                let containsAllChars = specialchar.split('').every(char => imgUrl.match(regexPattern).includes(char));
                if(containsAllChars) {
                    this.SignatureDetails.drawImage = imgUrl
                }else {
                    this.SignatureDetails.drawImage = `data:image/jpeg;base64,${imgUrl}`
                }
                var a = document.getElementById('scrollable-containerT')
                if(bool) {
                    a.scroll({
                        top: 700, 
                        left: 0, 
                        behavior: 'smooth'
                    });
                }
            // this.tabType = 'draw'
            this.openEditsignature =  true;
            this.SignatureDetails.editUpload = true
            }
        },
                SignatureEdit(obj){
                    
                    let signdata = obj.type == 'Typed' && obj.href ? obj.href.split(',') : obj.type == 'Drawn' && obj.data ? obj.data.split(',') : obj.type =='Uploaded' && obj.image ? obj.image.split(',') : [];
            let base64bitUrl = signdata && signdata.length > 0 ? signdata[signdata.length-1] : ''
            
            // this.EnableSignature = false
            // if(obj.type =='Uploaded' && (obj.data || obj.image)) {
                // this.IsNewSignature = true
                this.SignatureDetails.IsNewSignature = false
                // this.SignatureDetails ={
                //         EnableSignature : true
                //     }
                // this.SignatureDetails.EnableSignature = true
                this.SignatureDetails.uploadData = ""
                this.SignatureDetails.image = ""
                this.SignatureDetails.tabType = ""
                this.SignatureDetails.drawImage = ""
                this.SignatureDetails.IsNewSignature = false
                this.SignatureDetails.SignatureURL = ''

                if(obj.type == 'Typed'){
                  
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.href
                    this.SignatureDetails.image = obj.href
                    this.SignatureDetails.SignatureURL = obj.href
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = false
                    this.SignatureDetails.metaInformation = obj.metaInformation
                    // this.IsNewSignature = true
                    this.SignatureDetails.IsNewSignature = true
                    this.openEditsignature = false
                }
                if(obj.type == 'Uploaded'){
                   
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.image
                    this.SignatureDetails.SignatureURL = obj.image
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    this.SignatureDetails.IsNewSignature = true
                    this.openEditsignature = false
                }
            if(obj.type == 'Drawn'){
                this.SignatureDetails.EnableSignature = false
                this.SignatureDetails.uploadData = obj.data
                this.SignatureDetails.image = obj.data
                this.SignatureDetails.SignatureURL = obj.data
                // this.drawImage = obj.drawData
                this.SignatureDetails.tabType = obj.type
                this.SignatureDetails.Base64Url = base64bitUrl
                this.SignatureDetails.isDraw = true
                // this.IsNewSignature = true
                this.SignatureDetails.IsNewSignature = true
                this.openEditsignature = false
                }
                },
            saveSignature(obj) {
                
                let signdata = obj.type == 'Typed' && obj.href ? obj.href.split(',') : obj.type == 'Drawn' && obj.data ? obj.data.split(',') : [];
                    let base64bitUrl = signdata && signdata.length > 0 ? signdata[signdata.length-1] : ''
                    
                    // this.resetAttestation()
                    this.SignatureDetails.IsNewSignature = true
                    this.SignatureDetails.EnableSignature = true
                    this.SignatureDetails.uploadData = ""
                    this.SignatureDetails.image = ""
                    this.SignatureDetails.tabType = ""
                    this.SignatureDetails.drawImage = ""
                    this.IsNewSignature = false
    
                    if(obj.type == 'Typed'){
                        this.SignatureDetails.EnableSignature = false
                        this.SignatureDetails.uploadData = obj.href
                        this.SignatureDetails.image = obj.href
                        this.SignatureDetails.tabType = obj.type
                        this.SignatureDetails.Base64Url = base64bitUrl
                        this.SignatureDetails.isDraw = false
                        this.SignatureDetails.metaInformation = obj.metaInformation
                        this.IsNewSignature = true
                        // this.Section1.SignatureDetails.editUpload =true
                    }
                    if(obj.type == 'Uploaded'){
                        this.SignatureDetails.EnableSignature = false
                        this.SignatureDetails.uploadData = obj.data
                        this.SignatureDetails.image = obj.image
                        this.SignatureDetails.tabType = obj.type
                        this.SignatureDetails.Base64Url = obj.image
                        this.SignatureDetails.isDraw = true
                        this.IsNewSignature = true
                        // this.Section1.SignatureDetails.editUpload =true
                    }
                    if(obj.type == 'Drawn'){
                        this.SignatureDetails.EnableSignature = false
                        this.SignatureDetails.uploadData = obj.data
                        this.SignatureDetails.image = obj.data
                        // this.drawImage = obj.drawData
                        this.SignatureDetails.tabType = obj.type
                        this.SignatureDetails.Base64Url = base64bitUrl
                        this.SignatureDetails.isDraw = true
                        this.IsNewSignature = true
                        this.SignatureDetails.SignatureURL = obj.data
                        // this.Section1.SignatureDetails.editUpload =true
                    }
            },
            deleteSiganture(imgUrl){
                    // this.resetAttestation()
                    if(imgUrl){
                        this.SignatureDetails.IsNewSignature = true
                        this.SignatureDetails.EnableSignature = true
                        this.SignatureDetails.image = ''
                        this.SignatureDetails.Base64Url = ''
                        // this.$store.commit('updateWorkAuthorizationValue', { field: 'signature', value: '' })
                    }
                },
                updateValue(value){ 
                  let val = namevalidation.getValidName(value);
                  this.AssignedTraining.SignatoryAuthority.Name = val
                },
                onChangeSignatoryAuthority(selectedSignatoryAuthorityEmail){
                        if(selectedSignatoryAuthorityEmail)
                        {
                             var index = this.signatoryauthorityList.data.findIndex(x => x.id == selectedSignatoryAuthorityEmail);
                             if(index != -1) {
                                this.AssignedTraining.SignatoryAuthority.Name = this.signatoryauthorityList.data[index].text.replace(/\s?\(you\)\s*$/, '').trim();
                                this.AssignedTraining.SignatoryAuthority.Email = this.signatoryauthorityList.data[index].id;
                                this.AssignedTraining.SignatoryAuthority.Title = this.signatoryauthorityList.data[index].title;
                                if((this.AssignedTraining.SignatoryAuthority.Phone == null || this.AssignedTraining.SignatoryAuthority.Phone == '') && (this.signatoryauthorityList.data[index].phone != '' && this.signatoryauthorityList.data[index].phone != null))
                                {
                                    this.AssignedTraining.SignatoryAuthority.Phone = this.signatoryauthorityList.data[index].phone;
                                }
                                this.AssignedTraining.SignatoryAuthority.Role = this.signatoryauthorityList.data[index].Role;
                             }
                        }
    
                },
                getSignatoryauthorityList()
                {
                    this.showSignatoryauthorityList = false
                      this.$loading({loadingText: 'Please wait..'});
                   
                    ajax.get(`/I983/SignatoryList?employeeId=${this.content.Employee.EmployeeId}`,{},(res)=>{
                        this.signatoryauthorityList.data = __.map(res.data.SignatoryModelList, (t) => {
                            var name = t.BasicModel.Name;
                            if(t.Email == this.loggedInUserObj.email)
                            {
                              name = t.BasicModel.Name + " (you)";
                            }
                            return { 'id': t.Email, 'text': name, "title":t.Designation,"phone":t.Phone,"Role":t.Role ,"SAId":t.Id}
                        })
                        if(this.content.AssignedTraining.Supervisor != null){
                            this.selectedSignatoryAuthorityEmail = this.content.AssignedTraining.Supervisor.Email;
                        } else {
                            this.selectedSignatoryAuthorityEmail = this.AssignedTraining.SignatoryAuthority.Email;
                        }
                        this.showSignatoryauthorityList = true
    
                        this.$loading({ "loadingText": "Please wait.." }).close()
                    })
                },
    
                _IsTraininplanRequsted()
                {
                  if(this.TrainingPlan.Title ==''|| this.TrainingPlan.Title == null )
                  {
                     this.IsTraininplanRequsted = true;
                  }
                  else
                  {
                      this.IsTraininplanRequsted = false;
                  }
                },
                IsDocExist(docURL)
                {
                if(docURL != null && docURL != '' )
                {
                    return docURL
                }
                },
                addDocument(arr) {
                                arr.push({
                                DocUrl:'',
                })
                },
                removeDocument(index)
                {
                    this.SupportingDocuments.splice(index, 1)
                },
                addLink(arr) {
                    arr.push({
                        linkUrl:'',
                })
                },
                uploadComplete(index, fileQueue) {
                  if (fileQueue && fileQueue[0].response && fileQueue[0].response.Url) {
                    this.SupportingDocuments[index].DocUrl = fileQueue[0].response.Url
                    this.SupportingDocuments[index].isErrorMessageDisabled = false
                  }
                  if (fileQueue[0].response.State == false && fileQueue[0].response.Message != null)
                  {
                    this.SupportingDocuments[index].isErrorMessageDisabled = true
                    this.SupportingDocuments[index].errorMessageFrmResponse = fileQueue[0].response.Message
                    this.$refs.child1[index].CancelUpload()
                  }
                },
    
                resetData() { 
                    // Reset Values
                    this.AssignedTraining = {
                        SiteName:'',
                        SiteAddress:'',
                        SignatoryAuthority:
                        {
                            Name:'',
                            Title:'',
                            Email:'',
                            Phone:''
                        },
                   };
    
                    this.TrainingPlan = {
                        Title:'',
                        StudentRole:'',
                        GoalsAndObjectives:'',
                        EmployerOversight:'',
                        MeasuresAndAssessments:'',
                        Remarks:''
                    };
    
                    // Reset Validations
                    // this.$v.Evaluation.$reset();
                     this.$v.AssignedTraining.$reset();
                    this.$v.TrainingPlan.$reset();
                    this.$v.SignatureDetails.$reset();
                    // this.isshowValidSign = false
                },
                 getSupervisorDetails()
                    { 
                            var empId = this.content.Employee.EmployeeId;
                            var conId = this.loggedInUserObj.consultantId;
                            if(this.content.Employee.EmployeeId != this.loggedInUserObj.empId)
                            {
                                conId = this.$route.query.ConsultantId;
                            }
                        ajax.get(`/I983/GetSupervisorDetails?EmployeeId=${empId}&ConsultantId=${conId}`, {}, (res) => {
                            if(res.data.State == true && res.data.EmployeeDetail != null && res.data.EmployeeDetail.EmailId != null) {
                            var address1 = res.data.EmployeeDetail.Address.Address1 != null && res.data.EmployeeDetail.Address.Address1 != '' ? res.data.EmployeeDetail.Address.Address1 + "," : '';
                            var address2 = res.data.EmployeeDetail.Address.Address2 != null && res.data.EmployeeDetail.Address.Address2 != '' ? res.data.EmployeeDetail.Address.Address2 + "," : '';
                            var street = res.data.EmployeeDetail.Address.StreetNo != null && res.data.EmployeeDetail.Address.StreetNo != '' ? res.data.EmployeeDetail.Address.StreetNo + "," : '';
                            var AptNumber = res.data.EmployeeDetail.Address.AptNumber != null && res.data.EmployeeDetail.Address.AptNumber != '' ? res.data.EmployeeDetail.Address.AptNumber +"," : '';
                            var address = '';                        
                            if(!this.IsNullOrEmpty(address1))
                            {
                                address += address1
                            }
                            if(!this.IsNullOrEmpty(address2))
                            {
                                address += address2
                            }
                            if(!this.IsNullOrEmpty(street))
                            {
                                address += street
                            }
                            if(!this.IsNullOrEmpty(AptNumber))
                            {
                                address += AptNumber
                            }
                            if(!this.IsNullOrEmpty(city))
                            {
                                address += city
                            }
                            if(!this.IsNullOrEmpty(state))
                            {
                                address += state
                            }
                            if(!this.IsNullOrEmpty(zip))
                            {
                                address += zip
                            }                        
                            var name = res.data.EmployeeDetail.FirstName+" "+res.data.EmployeeDetail.LastName
                            var designation = res.data.EmployeeDetail.Designation;
                            
                            var signatoryAuthority = {
                               
                                Name: name,
                                Title: designation,
                                Email: res.data.EmployeeDetail.EmailId,
                                Phone: res.data.EmployeeDetail.PhoneNo,
                                }
                                this.AssignedTraining.SignatoryAuthority = signatoryAuthority;
                                this.AssignedTraining.SiteName = res.data.EmployeeDetail.ClientOrganizationName != '' && res.data.EmployeeDetail.ClientOrganizationName != null ? res.data.EmployeeDetail.ClientOrganizationName : res.data.EmployeeDetail.OrganizationName;
                                this.AssignedTraining.SiteAddress = address ;
                            }
                            else{ 
                            var signatoryAuthority = {
                                
                                Name: this.loggedInUserObj.Name,
                                Title: this.loggedInUserObj.Role,
                                Email: this.loggedInUserObj.Email,
                                Phone: '',
                                }
                                this.AssignedTraining.SiteName = this.loggedInUserObj.OrgName;
                                this.AssignedTraining.SiteAddress = this.loggedInUserObj.OrgAddress;
                                this.AssignedTraining.SignatoryAuthority = signatoryAuthority
                            }
                        })
                    },
                copyFromStore() { 
                    
                    this.resetData();
    
                    this.AssignedTraining.SiteName = this.clonedContent.AssignedTraining.SiteName;
                    this.AssignedTraining.SiteAddress = this.clonedContent.AssignedTraining.SiteAddress;
    
                    this.AssignedTraining.SignatoryAuthority.Name = this.clonedContent.AssignedTraining.SignatoryAuthority.Name;
                    this.AssignedTraining.SignatoryAuthority.Title = this.clonedContent.AssignedTraining.SignatoryAuthority.Title;
                    this.AssignedTraining.SignatoryAuthority.Email = this.clonedContent.AssignedTraining.SignatoryAuthority.Email;
                    this.AssignedTraining.SignatoryAuthority.Phone = this.clonedContent.AssignedTraining.SignatoryAuthority.Phone ;

                    this.SignatureURL = this.clonedContent.AssignedTraining.SignatureURL ? this.clonedContent.AssignedTraining.SignatureURL : ''
    
                    this.SignatureDetails.SignatureURL = this.clonedContent.AssignedTraining.SignatureURL
                    this.SignatureDetails.SignedDate = this.clonedContent.AssignedTraining.SignedDate
                    this.SignatureDetails.Base64Url = this.clonedContent.AssignedTraining.Base64EncodedSignature
                    this.SignatureDetails.EnableSignature = this.clonedContent.AssignedTraining.SignatureURL && this.clonedContent.AssignedTraining.SignatureURL != '' ? false : true,
                    this.SignatureDetails.tabType = this.clonedContent.AssignedTraining.SigningType
                    this.SignatureDetails.image = this.clonedContent.AssignedTraining.Base64EncodedSignature

                    if((this.AssignedTraining.SignatoryAuthority.Name == null || this.AssignedTraining.SignatoryAuthority.Name == null) && (this.AssignedTraining.SignatoryAuthority.Email == null || this.AssignedTraining.SignatoryAuthority.Email == '') )
                    {
                        this.getSupervisorDetails();
                    }
    
                    this.TrainingPlan.Title = this.clonedContent.AssignedTraining.Training.Title;
                    this.TrainingPlan.StudentRole = this.clonedContent.AssignedTraining.Training.StudentRole;
                    this.TrainingPlan.GoalsAndObjectives = this.clonedContent.AssignedTraining.Training.Objectives;
                    this.TrainingPlan.EmployerOversight = this.clonedContent.AssignedTraining.Training.EmployerOverSight;
                    this.TrainingPlan.MeasuresAndAssessments = this.clonedContent.AssignedTraining.Training.Assessments;
                    this.TrainingPlan.Remarks = this.clonedContent.AssignedTraining.Training.AdditionalRemarks;
    
                    if(this.clonedContent.AssignedTraining.Training.SupportingDocument && this.clonedContent.AssignedTraining.Training.SupportingDocument.length > 0)
                    {
                        this.SupportingDocuments = this.clonedContent.AssignedTraining.Training.SupportingDocument.filter(v=> {
                                                          return v.DocUrl!='' && v.DocUrl!= null});
                    }
                    if(this.clonedContent.AssignedTraining.Training.SupportingLink && this.clonedContent.AssignedTraining.Training.SupportingLink.length > 0)
                    {
    
                         this.SupportingLinkOptions.data = __.map(this.clonedContent.AssignedTraining.Training.SupportingLink, t => {
                                return {
                                id: t,
                                text: t,
                                };
                            });
                        this.SupportingLinks = this.clonedContent.AssignedTraining.Training.SupportingLink;
                        this.SupportingLinks = this.SupportingLinks.filter(v=>v!='');
                    }
                },
                copyToStore() {
                    
                this.clonedContent.AssignedTraining.SiteName = this.AssignedTraining.SiteName;
                this.clonedContent.AssignedTraining.SiteAddress = this.AssignedTraining.SiteAddress;
                this.clonedContent.AssignedTraining.SignatoryAuthority.Name = this.AssignedTraining.SignatoryAuthority.Name.includes("(you)") ? this.AssignedTraining.SignatoryAuthority.Name.replace("(you)", "").trim() : this.AssignedTraining.SignatoryAuthority.Name
                this.clonedContent.AssignedTraining.SignatoryAuthority.Title = this.AssignedTraining.SignatoryAuthority.Title;
                this.clonedContent.AssignedTraining.SignatoryAuthority.Email = this.AssignedTraining.SignatoryAuthority.Email;
                this.clonedContent.AssignedTraining.SignatoryAuthority.Phone = this.AssignedTraining.SignatoryAuthority.Phone;
    
                this.clonedContent.AssignedTraining.Training.Title  = this.TrainingPlan.Title;
                this.clonedContent.AssignedTraining.Training.StudentRole = this.TrainingPlan.StudentRole;
                this.clonedContent.AssignedTraining.Training.Objectives = this.TrainingPlan.GoalsAndObjectives;
                this.clonedContent.AssignedTraining.Training.EmployerOverSight = this.TrainingPlan.EmployerOversight;
                this.clonedContent.AssignedTraining.Training.Assessments = this.TrainingPlan.MeasuresAndAssessments;
                this.clonedContent.AssignedTraining.Training.AdditionalRemarks = this.TrainingPlan.Remarks;
                this.clonedContent.AssignedTraining.SectionStatus = "Completed"; // On Update
                
                this.clonedContent.AssignedTraining.SignedDate = this.SignatureDetails.SignedDate;
                this.clonedContent.AssignedTraining.SignatureURL = this.SignatureDetails.image;
                this.clonedContent.AssignedTraining.Base64EncodedSignature = this.SignatureDetails.Base64Url
                this.clonedContent.AssignedTraining.SigningType = this.SignatureDetails.tabType

                if(this.clonedContent.AssignedTraining.SignatureURL != null && this.clonedContent.AssignedTraining.SignatureURL != '')
                {
                    this.clonedContent.AssignedTraining.SignedDocumentStatus = "";
                    this.clonedContent.AssignedTraining.IsSignedBySupervisor = true;
                }
                else
                {
                    this.clonedContent.AssignedTraining.SignedDocumentStatus = "Pending Physical Signature";
                }

                var supportingLinks = this.SupportingLinks;
                this.clonedContent.AssignedTraining.Training.SupportingLink = supportingLinks;
                this.clonedContent.AssignedTraining.Training.SupportingDocument = this.SupportingDocuments.filter(v=> {                
                      return v.DocUrl!='' && v.DocUrl!= null});

                // Insert into modified log
                this.$parent.$parent.insertModifiedLogToStore('AssignedTraining');
            },
                onUpdateClick()
                { 
                     this.$v.AssignedTraining.$touch();
                     this.$v.TrainingPlan.$touch();
                     this.$v.selectedSignatoryAuthorityEmail.$touch();
    
                     var supportingLinks =  this.SupportingLinks;
                  this.$v.SignatureDetails.$touch();
                    if(this.$v.AssignedTraining.$invalid  == false && this.$v.TrainingPlan.$invalid  == false && this.$v.selectedSignatoryAuthorityEmail.$invalid  == false  )
                    { 
                        this.TrainingObj = {
                            Employee:{
                                Name:this.content.Employee.Name
                            },
                            Employer: {
                                Name:this.content.Employer.Name,
                            },
                            AssignedTraining: {
                                 SiteName: this.AssignedTraining.SiteName,
                                 SiteAddress: this.AssignedTraining.SiteAddress,
                                SignatoryAuthority: {
                                    Title: this.AssignedTraining.SignatoryAuthority.Title == 'HRManager' ? 'HR Manager': this.AssignedTraining.SignatoryAuthority.Title,
                                    Email: this.AssignedTraining.SignatoryAuthority.Email,
                                    Phone: this.AssignedTraining.SignatoryAuthority.Phone,
                                    Name: this.AssignedTraining.SignatoryAuthority.Name.includes("(you)") ? this.AssignedTraining.SignatoryAuthority.Name.replace("(you)", "").trim() : this.AssignedTraining.SignatoryAuthority.Name,
                                    Role: this.AssignedTraining.SignatoryAuthority.Role
    
                                },
                                Training: {
                                    Title: this.TrainingPlan.Title == 'HRManager' ? 'HR Manager': this.TrainingPlan.Title,
                                    StudentRole: this.TrainingPlan.StudentRole,
                                    Objectives: this.TrainingPlan.GoalsAndObjectives,
                                    EmployerOverSight: this.TrainingPlan.EmployerOversight,
                                    Assessments: this.TrainingPlan.MeasuresAndAssessments,
                                    AdditionalRemarks: this.TrainingPlan.Remarks,
                                    SupportingDocument:this.SupportingDocuments.filter(v=> {
                                                          return v.DocUrl!='' && v.DocUrl!= null}),
                                    SupportingLink:supportingLinks
                                },
                                SignedDate: this.SignatureDetails.SignedDate,
                                Base64EncodedSignature: this.SignatureDetails.Base64Url,
                                signingType:this.SignatureDetails.tabType,
    
    
                            },
                                GeoLocation: this.SignatureDetails.IsNewSignature ? 'SignatureSigned' : null,
                                UserAgent:navigator.userAgent
                        };
    
                                if(this.isverify || this.IsReviewTrainingPlan) {
                                    this.$loading({'loadingText': 'Previewing Training Plan...'});
                                    this.$parent.previewDocument("AssignedTraining", this.TrainingObj)
                                } else {
                                    this.updateTrainingPlan()
                                }
                        }
                },
              updateTrainingPlan()
              {
                    this.$loading({loadingText: 'Updating Training Plan Details...'});
                    ajax.put(`/I983/${this.content.Id}/UpdateTrainingPlan`, this.TrainingObj, (res) => {
                        //window.bus.fire('SendI983RefreshSignal', '');
                        setTimeout(() => {
                            this.$loading({}).close()
                        }, 1000);
                        if(res.data.State == true){
                            this.$message({
                                type: 'success',
                                message: 'Training Plan updated successfully'
                            });
                            this.copyToStore();
                            if(this.IsTraininplanRequsted) {
                            this.addTrainingToSettings();
                            }
                            this.show = false
                        }
                        else
                            this.ESSEnableDisable(res)
                    });
               },
                addTrainingToSettings() {
    
                     var supportingLinks =  this.SupportingLinks;
    
                    var training = {
                                    Title: this.TrainingPlan.Title == 'HRManager' ? 'HR Manager': this.TrainingPlan.Title,
                                    StudentRole: this.TrainingPlan.StudentRole,
                                    Objectives: this.TrainingPlan.GoalsAndObjectives,
                                    EmployerOverSight: this.TrainingPlan.EmployerOversight,
                                    Assessments: this.TrainingPlan.MeasuresAndAssessments,
                                    AdditionalRemarks: this.TrainingPlan.Remarks,
                                    SupportingDocument:this.SupportingDocuments.filter(v=> {
                                                          return v.DocUrl!='' && v.DocUrl!= null}),
                                    SupportingLink:supportingLinks
                                }
    
                    ajax.post(`/Training/Add`, training, (res) => {
                        if (res.data.State == true) {
    
                        }
                        else
                            this.ESSEnableDisable(res)
                    });
                },
            }
        }
    </script>
    <style lang="scss" scoped>
       .title-content
       {
           color: #4a90e2;
           font-size: 14px;
       }
       .rowgap
       {
           margin-top: 10px;
       }
       .validation-star{
                color: #F31D1D;
        }
        .radio-inline
        {
            padding-left: 0px
        }
        label{
    
             color :#a4abb9
        }
        .preview-details {
            padding: 10px 0;
        }
        .add-doc{
        font-size: 15px;
        font-style: italic;
        font-weight: bolder;
        text-decoration: underline;
        float: right;
        }
        .remove-doc{
            color: #D0032E;;
            font-size: 15px;
            font-style: italic;
            font-weight: bolder;
            text-decoration: underline;
            float: right;
        }
        .edit-sign-icon {
            height: 35px;
            width: 35px;
            cursor: pointer;
            margin-bottom: 20px;
        }
        .delete-sign-icon {
            height: 35px;
            width: 35px; 
            margin-bottom: -65px;
            cursor: pointer;
        }
        .custom-sign-div {
            flex: 1 1 auto;
            min-height: 1px;
            /* padding: 1.5rem; */
            background: #FCFCFF;
            text-align: center;
            border: 1px solid rgba(219,219,232,0.50);
            width: 650px;
            height:139px !important;
            padding: 20px 15px;
        }
        .custom-sign-div_inline_style1{
            display:inline-block;
            height:100px;
            width:49%;
            float:left; 
        }
        .custom-sign-div_inline_style2 {
            display: inline-block;
            margin-left: 15px;
            width: 20%;
        }
        .delete-sign-icon {
            height: 35px;
            width: 35px; 
            margin-bottom: -65px;
            cursor: pointer;
        }
        .custom-sign-div {
            flex: 1 1 auto;
            min-height: 1px;
            /* padding: 1.5rem; */
            background: #FCFCFF;
            text-align: center;
            border: 1px solid rgba(219,219,232,0.50);
            width: 650px;
            height:139px !important;
            padding: 20px 15px;
        }
        .custom-sign-div_inline_style1{
            display:inline-block;
            height:100px;
            width:49%;
            float:left; 
        }
    </style>
    


// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/UpdateTrainingPlanPopup.vue